import { render, staticRenderFns } from "./CulturalAdmin.vue?vue&type=template&id=053f04f2&scoped=true&"
import script from "./CulturalAdmin.vue?vue&type=script&lang=js&"
export * from "./CulturalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CulturalAdmin.vue?vue&type=style&index=0&id=053f04f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f04f2",
  null
  
)

export default component.exports